export default __webpack_public_path__ + "static/media/mana3.49c1c6f1.svg";